import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Container,
  Button,
  Box,
  Typography,
  Grid,
  Menu,
  Modal,
  MenuItem,
  IconButton,
  CircularProgress,
  TextField,
  Popover,
  useMediaQuery,
} from "@mui/material";

import Select from "react-select";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import axios from "axios";
import { useAlert } from "react-alert";
import HelpIcon from "@mui/icons-material/Help";
import fileDownload from "js-file-download";
import Moment from "moment";
import { useForm, Controller } from "react-hook-form";
import Fade from "@mui/material/Fade";
import { FileUploader } from "react-drag-drop-files";
import LoadingButton from "@mui/lab/LoadingButton";
import Download from "@mui/icons-material/Download";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Backdrop } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";

const HelpDropDown = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDrop = () => {
    setAnchorEl(null);
  };
  const rights = useSelector((state) => state.login.rights);

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const alert = useAlert();
  const [docslist, setdocslist] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [docError, setdocError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [date, setdate] = useState(Moment().format("YYYY-MM-DD"));
  const [LinkUrl, setLinkUrl] = useState("");
  const [fileurl, setfileurl] = useState("");
  const isTabletOrMobile = useMediaQuery("(max-width:768px)");
  const [LinkName, setLinkName] = useState("");
  const [base64, setbase64] = useState("");
  const [DocumentName, setDocumentName] = useState("");
  const options = [
    { value: "upload", label: "Upload Document" },
    { value: "weburl", label: "Web URL" },
  ];
  const [documentType, setDocumentType] = useState(null);
  const [opendocs, setopendocs] = useState(false);
  const [urlFile, seturlFile] = useState("");
  const [urldownload, seturldownload] = useState("");
  const [DocName, setDocName] = useState("");
  const [FullDocName, setFullDocName] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [file, setFile] = useState(null);

  const [filename, setfilename] = useState([]);
  const [base64Data, setBase64Data] = useState([]);
  const [totalProgress, setTotalProgress] = React.useState(0);
  const [savedFiles, setSavedFiles] = React.useState([]);

  const fields = [
    "id",
    "documentName",
    "fileUrl",
    "patientId",
    "practiceId",
    "deleted",
    "date",
    "createdBy",
    "clientCreatedDate",
    "updatedBy",
    "clientUpdatedDate",
    "createdDate",
    "updatedDate",
    "base64",
    "authId",
    "authorizationcptId",
    "notificationId",
    "type",
    "referringProvider",
    "referringPhysiciansId",
  ];
  const defValues = {
    id: 0,
    documentName: "",
    fileUrl: "",
    patientId: 0,
    practiceId: "",
    date: "",
    createdBy: "",
    referringProvider: "",
    referringPhysiciansId: 0,
    Deleted: false,
    clientCreatedDate: "",
    updatedBy: "",
    clientUpdatedDate: "",
    createdDate: "",
    updatedDate: "",
    base64: "",
    authorizationcptId: "",
    notificationId: "",
    authId: "",
    type: "",
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      documentName: cell.row.documentName,
      date: cell.row.date,
      id: Delbyid,
      deleted: true,
    };
    axios
      .post(
        `${
          process.env.REACT_APP_API_URL
        }/PatientDocument/PatientDocument?patientId=${-9}`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setRefresh(!refresh);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [EditTime, setEditTime] = useState(false);
  const [EditTimePayload, setEditTimePayload] = useState(null);
  const filteredDocs = docslist.filter((doc) =>
    (doc.documentName || "")
      .toLowerCase()
      .includes((searchQuery || "").toLowerCase())
  );

  const appointmentDocslist = [
    {
      field: "documentName",
      headerName: "Document Name",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      renderCell: (cellValues) => (
        <>
          <Tooltip title={`${cellValues.value}`} placement="left">
            <div>
              <Button
                onClick={() => {
                  setopendocs(true);
                  setLinkName(cellValues.row.linkText);
                  setLinkUrl(cellValues.row.linkUrl);
                  setFullDocName(cellValues.row.documentName);
                  // seturlFile(cellValues.row.fileUrl)
                  var url = cellValues.row.fileUrl;
                  seturldownload(cellValues.row.fileUrl);
                  if (!cellValues.row.linkUrl) {
                    axios
                      .get(
                        `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${url}`,
                        {
                          headers,
                        }
                      )
                      .then((response) => {
                        // setisLoading(false)
                        seturlFile(response);
                      })
                      .catch((error) => {
                        console.error("There was an error!", error);
                      });

                    var arr = cellValues.row.documentName.split(".");
                    setDocName(arr.length > 0 ? arr[1].toLowerCase() : "");
                    setFullDocName(cellValues.row.documentName);
                  }
                  // console.log('pic flied::', cellValues.row.documentName)
                }}
              >{`${cellValues.value}`}</Button>
            </div>
          </Tooltip>
        </>
      ),
    },
    {
      field: "date",
      headerName: "Document Date",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.7,
    },
    // {
    //   field: 'Edit',
    //   headerName: 'Edit',
    //   headerClassName: 'super-app-theme--header',
    //   flex: 0.5,
    //   renderCell: cellValues => (
    //     <>
    //       <Tooltip title={`${cellValues.value}`} placement='left'>
    //         <div>
    //           <Button
    //             onClick={() => {
    //               setOpen(true)
    //               setLinkName(cellValues.linkText)
    //               setLinkUrl(cellValues.linkUrl)
    //               setEditTime(true)
    //               let RowId = cellValues.row.id
    //               axios
    //                 .get(`${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocumentById?Id=${RowId}`, {
    //                   headers
    //                 })
    //                 .then(response => {
    //                   fields.forEach(field => {
    //                     setValue(field, response[field]);
    //                   })
    //                   setEditTimePayload(response)
    //                   setDocumentName(response.documentName)
    //                   var dateto12 = Moment(response.date).format('YYYY-MM-DD')
    //                   setdate(dateto12)

    //                 })
    //                 .catch(error => {
    //                   console.error('There was an error!', error)
    //                 })

    //             }}
    //           > <EditIcon /></Button>
    //         </div>
    //       </Tooltip>
    //     </>
    //   )
    // },
    ...(rights?.Edit_help
      ? [
          {
            field: "Edit",
            headerName: "Edit",
            headerClassName: "super-app-theme--header",
            flex: 0.5,
            renderCell: (cellValues) => (
              <>
                <Tooltip title={`${cellValues.value}`} placement="left">
                  <div>
                    <Button
                      onClick={() => {
                        setOpen(true);

                        setEditTime(true);
                        let RowId = cellValues.row.id;
                        axios
                          .get(
                            `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocumentById?Id=${RowId}`,
                            {
                              headers,
                            }
                          )
                          .then((response) => {
                            fields.forEach((field) => {
                              setValue(field, response[field]);
                            });
                            setfileurl(response.fileUrl);
                            setLinkName(response.linkText);
                            setLinkUrl(response.linkUrl);
                            setEditTimePayload(response);
                            setDocumentName(response.documentName);
                            var dateto12 = Moment(response.date).format(
                              "YYYY-MM-DD"
                            );
                            setdate(dateto12);
                          })
                          .catch((error) => {
                            console.error("There was an error!", error);
                          });
                      }}
                    >
                      {" "}
                      <EditIcon />
                    </Button>
                  </div>
                </Tooltip>
              </>
            ),
          },
        ]
      : []),

    ...(rights?.Delete_Help
      ? [
          {
            field: "delete",
            headerClassName: "super-app-theme--header",
            headerName: "Action",
            minWidth: 100,
            align: "center",
            headerAlign: "center",
            renderCell: (cell) => (
              <>
                <DeleteIcon
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  color="black"
                  onClick={() => {
                    setDialogOpen(true);
                    setDelbyid(cell.row.id);
                  }}
                />

                <Dialog
                  open={isDialogOpen}
                  onClose={() => setDialogOpen(false)}
                  aria-labelledby="delete-dialog-title"
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    invisible: true,
                  }}
                  PaperProps={{
                    style: {
                      marginRight: "5px",
                      float: "right",
                      marginTop: "5px",
                      color: "red",
                      cursor: "pointer",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      width: "500px",
                    }}
                  >
                    <ErrorOutlineIcon
                      style={{ fontSize: "100px", color: "red" }}
                    />
                    <DialogTitle
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: " 1.25rem",
                      }}
                    >
                      Are you sure?
                    </DialogTitle>
                    <h5
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "normal",
                        color: "#444444",
                      }}
                    >
                      You won't be able to revert this!
                    </h5>
                    <DialogContent>
                      <DialogContentText>
                        <Grid style={{ marginTop: "1rem" }}>
                          <Button
                            onClick={() => setDialogOpen(false)}
                            style={{
                              backgroundColor: "#6c7c84",
                              color: "white",
                              marginBottom: "1rem",
                            }}
                          >
                            No, cancel!
                          </Button>
                          <Button
                            onClick={() => handleDelete(cell)}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "1rem",
                              marginBottom: "1rem",
                              border: "1px solid #b4acec",
                            }}
                          >
                            Yes, delete it!
                          </Button>
                        </Grid>
                      </DialogContentText>
                    </DialogContent>
                  </div>
                </Dialog>
              </>
            ),
          },
        ]
      : []),
  ];

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
  });

  const handleOpenn = () => {
    setOpen(true);
    setSubmitting(false);
    setbase64("");
    setfilename("");
  };

  function applyRefresh() {
    setRefresh(!refresh);
  }
  const handleClose = () => {
    setopendocs(false);
    setFile(null);
    setOpen(false);
    setSubmitting(false);

    setRefresh(true);
    setfilename([]);
    setBase64Data([]);
    setDocumentName("");
    setEditTime(false);
    setDocumentType(null);
    setdate("");
    setdocError(false);
    setLinkUrl("");
    setLinkName("");
  };

  useEffect(() => {
    setSpinner(true);
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/PatientDocument/PatientDocumentList?patientId=${-9}`,
        { headers }
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });
        setSpinner(false);
        setdocslist(response);
      })

      .catch((error) => {
        setSpinner(false);
        console.error("There was an error!", error);
      });
  }, [refresh, anchorEl]);

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
    "& .MuiDataGrid-row": {
      height: "auto",
    },
    "& .MuiDataGrid-main": {
      minHeight: "60%",
    },
  };
  const styleofmodal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 950,
    // height: 500,
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: 4,
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "70vh", // Fixed height using viewport units (or you can use px like "600px")
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    overflowY: "auto", // This enables vertical scrolling when content overflows
    maxHeight: "90vh", // Optional: prevents the modal from becoming too tall
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const [sizeError, setSizeError] = useState(false);
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
  const handleChangeforfile = async (files) => {
    const newFilenames = [];
    const newBase64Data = [];

    // setSizeError(false)

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // // Validate file size (10 MB limit)
      // if (file.size > MAX_FILE_SIZE) {
      //   setSizeError(true)
      //   return // Stop processing if any file is too large
      // }

      const base64 = await fileToBase64(file);
      newFilenames.push(file.name);
      newBase64Data.push(base64);
    }

    setfilename(newFilenames);
    setdocError(false);
    setBase64Data(newBase64Data);
    setdocError(false);
  };
  const onSubmit = (data) => {
    if (!EditTime) {
      const hasValidFile = base64Data.length > 0 || LinkUrl;
      if (!date || !hasValidFile) {
        setdocError(true);
        setSubmitting(false);
        return;
      }
    }

    if (sizeError) {
      setSizeError(true);
      setSubmitting(false);
      return;
    }
    setdocError(false);
    setSubmitting(true);
    setSavedFiles([]);

    const postData = [];
    let totalLength = 0;

    if (!EditTime) {
      for (let i = 0; i < base64Data.length; i++) {
        const documentData = {
          patientId: -9,
          date: date || EditTimePayload.date,
          documentName: filename[i] || DocumentName,
          base64: base64Data[i],
          linkText: LinkName,
          linkUrl: LinkUrl,
        };
        postData.push(documentData);
        totalLength += base64Data[i].length;
      }

      // If no file was selected but linkUrl is present, still allow post
      if (base64Data.length === 0 && LinkUrl) {
        const documentData = {
          patientId: -9,
          date: date,
          documentName: LinkName || DocumentName,
          base64: "", // no file
          linkText: LinkName,
          linkUrl: LinkUrl,
          // fileurl:LinkUrl
        };
        postData.push(documentData);
      }
    } else {
      // Edit mode — one document
      const documentData = {
        id: EditTimePayload.id,
        patientId: -9,
        date: date || EditTimePayload.date,
        documentName: filename[0] || DocumentName,
        base64: base64Data[0] || "", // safe fallback
        linkText: LinkName,
        linkUrl: LinkUrl,
        fileurl: LinkUrl ? "" : fileurl,
      };
      postData.push(documentData);
    }

    // Start uploading
    const requests = postData.map((documentData, index) => {
      const config = {
        onUploadProgress: function (progressEvent) {
          const progress = Math.round(
            (progressEvent.loaded / totalLength) * 1.5
          );
          setTotalProgress(progress <= 100 ? progress : 100);
        },
        headers,
      };

      return axios
        .post(
          `${
            process.env.REACT_APP_API_URL
          }/PatientDocument/PatientDocument?patientId=${-9}`,
          documentData,
          config
        )
        .then((response) => {
          setSavedFiles((prev) => [...prev, index]);
          setSubmitting(false);
          setSpinner(false);
          setOpen(false);

          if (response) {
            alert.success("Document uploaded successfully.", {
              type: "success",
              onClose: () => {
                handleClose();
                applyRefresh();
              },
            });
          }
        })
        .catch((error) => {
          setSubmitting(false);
          setSpinner(false);
          console.error(error);
          toast.error(`Error: ${error.message}`, {
            type: "error",
          });
        });
    });

    // Optional: wait for all uploads to finish
    Promise.all(requests);
  };

  const download = (url, filename) => {
    setSpinner(true);
    setSubmitting(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`,
        {
          headers,
          responseType: "blob",
        }
      )
      .then((res) => {
        setopendocs(false);
        setSpinner(false);
        setSubmitting(false);
        fileDownload(res, filename);
      })
      .catch((err) => {
        setSubmitting(false);
        console.log(err);
      });
  };
  const handleRename = (index, newName) => {
    const updatedFilenames = [...filename];
    updatedFilenames[index] = newName; // Update the filename at the specific index
    setfilename(updatedFilenames);
  };
  const OPEN = Boolean(anchorEl);
  return (
    <React.Fragment>
      <div className="d-flex">
        <Grid
          style={{
            display: "flex",
            width: "auto",
            borderRadius: "7px",
            height: isTabletOrMobile ? "40px" : "55px",
          }}
        >
          <Button
            variant="contained"
            onClick={handleClick}
            sx={{
              backgroundColor: "#0d7f6a",
              color: "white",
              borderRadius: "30px",
              width: isTabletOrMobile ? "40px" : "250px", // mobile: small square, desktop: full
              height: isTabletOrMobile ? "40px" : "38px",
              minWidth: "40px",
              textTransform: "none",
              marginTop: isTabletOrMobile ? "15px" : "15px",
              marginRight: isTabletOrMobile ? "25px" : "15px",
              padding: isTabletOrMobile ? "0" : "0 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                background: "#2c5e4e",
              },
            }}
            startIcon={<HelpIcon sx={{ fontSize: 20 }} />}
          >
            {!isTabletOrMobile && "Help / Search"}
          </Button>
        </Grid>
      </div>

      {/* <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseDrop}
        PaperProps={{
          style: {
            width: '600px', // Increased Width
            height: '500px', // Fixed Height
            padding: '20px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
            borderRadius: '10px',
            overflowY: 'auto', // Vertical scrollbar only when needed
            overflowX: 'hidden', // Hide horizontal scrollbar
          }
        }}
      > */}
      <Popover
        open={OPEN}
        anchorEl={anchorEl}
        onClose={handleCloseDrop}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            width: "600px",
            height: "500px",
            padding: "20px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            overflowY: "auto",
            overflowX: "hidden",
          },
        }}
      >
        <Box
          p={1.5}
          style={{ backgroundColor: "#377562", borderRadius: "6px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#fff",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              Help Documents
            </Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs={6} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search Document..."
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ mb: 2 }}
            />
          </Grid>
          {rights.Add_Help && (
            <Grid item xs={3}>
              <Button
                className="Button"
                sx={{ mb: 2 }}
                onClick={handleOpenn}
                size="small"
                // fullWidth
                style={{
                  width: "120px",
                  float: "right",
                  height: "33px",
                  marginTop: "10px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                  marginRight: "15px",
                }}
              >
                <AddOutlinedIcon
                  fontSize="medium"
                  style={{
                    color: "white",
                    paddingRight: "4px",
                    paddingBottom: "2px",
                  }}
                ></AddOutlinedIcon>
                Add New
              </Button>
            </Grid>
          )}

          <Grid item xs={3}>
            <Button
              className="Button"
              sx={{ mb: 2, marginRight: "20px", marginTop: "10px" }}
              onClick={(event) => {
                applyRefresh();
              }}
              // fullWidth
              style={{
                marginBottom: "10px",
                float: "right",
                marginLeft: "20px",
                width: "120px",
                height: "35px",
                // backgroundColor: '#A574FD',
                color: "white",
                fontSize: "14px",
              }}
            >
              <CachedOutlinedIcon
                fontSize="medium"
                style={{
                  color: "white",
                  marginRight: "1px",
                  paddingRight: "0px",
                  paddingBottom: "2px",
                }}
              ></CachedOutlinedIcon>
              Refresh
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Box mb={1}>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ height: 328, width: "100%" }}
              >
                {spinner ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <CircularProgress />
                  </Box>
                ) : docslist === null || docslist.length === 0 ? (
                  "No Record Found"
                ) : (
                  <DataGrid
                    rows={filteredDocs}
                    columns={appointmentDocslist}
                    headerHeight={37}
                    sx={gridRowStyle}
                    pagination
                    autoPageSize
                  />
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          // BackdropProps={{
          //   timeout: 500
          // }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Grid container columnSpacing={0}>
                <Grid
                  container
                  spacing={0}
                  style={{
                    backgroundColor: "#377562",
                  }}
                >
                  <Grid
                    item
                    xs={9}
                    style={{
                      fontWeight: 500,
                      backgroundColor: "#377562",
                      marginTop: "10px",
                    }}
                  >
                    <Typography
                      style={{
                        fontWeight: "bold",
                        marginLeft: "7px",
                        fontSize: "18px",
                        color: "white",
                      }}
                    >
                      Upload Help Document
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      onClick={handleClose}
                      variant="gradient"
                      // disabled={submitting}
                      style={{
                        marginTop: "10px",
                        float: "right",
                        marginBottom: "10px",
                        // width: "80px",
                        height: "35px",

                        color: "black",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}

                      // startIcon={<img src={SaveIcon} style={{marginTop:'-3px',marginRight:'-6px',}}/>}
                    >
                      <CancelOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "red",

                          paddingBottom: "2px",
                        }}
                      ></CancelOutlinedIcon>
                    </Button>
                  </Grid>
                </Grid>
                {EditTime === true && (
                  <Grid
                    item
                    xs={11}
                    style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                  >
                    <Typography style={{ color: "black" }}>
                      Document/Link Name
                    </Typography>
                    <TextField
                      size="small"
                      value={DocumentName}
                      onChange={(e) => {
                        setDocumentName(e.target.value);
                      }}
                      width="auto"
                      fullWidth
                      placeholder="Enter Document Name"
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={11}
                  style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                >
                  <Typography style={{ color: "black" }}>Date</Typography>
                  <TextField
                    type="date"
                    size="small"
                    value={date}
                    onChange={(e) => {
                      setdate(e.target.value);
                      setdocError(false);
                    }}
                    width="auto"
                    fullWidth
                    placeholder="Select date"
                  />
                </Grid>
                {EditTime == false && (
                  <Grid
                    item
                    xs={11}
                    style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                  >
                    <Typography style={{ color: "black" }}>
                      Document Type
                    </Typography>
                    <Select
                      options={options}
                      value={documentType}
                      onChange={setDocumentType}
                      placeholder="Select Document Type"
                    />
                  </Grid>
                )}
                {documentType?.value === "weburl" && (
                  <>
                    <Grid
                      item
                      xs={11}
                      style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                    >
                      <Typography style={{ color: "black" }}>
                        Link Name
                      </Typography>
                      <TextField
                        size="small"
                        value={LinkName}
                        onChange={(e) => {
                          setLinkName(e.target.value);
                        }}
                        width="auto"
                        fullWidth
                        placeholder="Input Link Name"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={11}
                      style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                    >
                      <Typography style={{ color: "black" }}>
                        Link Url
                      </Typography>
                      <TextField
                        size="small"
                        value={LinkUrl}
                        onChange={(e) => {
                          setLinkUrl(e.target.value);
                          setdocError(false);
                        }}
                        width="auto"
                        fullWidth
                        placeholder="Input Link Url"
                      />
                    </Grid>
                  </>
                )}
                {filename.length > 0 && (
                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <h4>Uploaded Files (Edit Names Below):</h4>
                    {filename.map((name, index) => (
                      <Grid
                        container
                        spacing={2}
                        key={index}
                        style={{ marginBottom: 10 }}
                      >
                        <Grid item xs={8}>
                          <TextField
                            fullWidth
                            label={`File ${index + 1}`}
                            value={name}
                            size="small"
                            onChange={(e) =>
                              handleRename(index, e.target.value)
                            }
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Grid>
              {documentType?.value === "upload" && (
                <>
                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <Button
                      className="Button"
                      variant="contained"
                      component="label"
                    >
                      Upload
                      <input
                        type="file"
                        name="file"
                        accept="video/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
                        onInput={(e) => handleChangeforfile(e.target.files)}
                        style={{ display: "none" }}
                        multiple
                      />
                    </Button>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                    <FileUploader
                      multiple={true}
                      handleChange={handleChangeforfile}
                      name="file"
                    />
                  </Grid>
                </>
              )}
              {sizeError && (
                <Grid item xs={12} style={{ marginTop: 15, color: "red" }}>
                  Please select files smaller than 10 MB
                </Grid>
              )}
              {!EditTime && (
                <Grid item xs={12} style={{ marginTop: "5px", marginLeft: 15 }}>
                  <Typography>
                    {" "}
                    To Upload files Please click on upload button and then Save
                    it
                  </Typography>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                style={{ marginTop: "5px", marginLeft: 15 }}
              ></Grid>
              {/* <Grid item xs={12} style={{ marginTop: '5px' }}>
                {file && <p>Currently uploading: {file.name}</p>}
              </Grid> */}
              <Grid>
                {docError ? (
                  <Typography style={{ color: "red" }}>
                    Please select document/Document Url and date
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={12} style={{ fontWeight: 500 }}>
                {submitting ? (
                  <Grid>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <CircularProgress />
                    </Box>

                    <Typography variant="bold" component="div" color="#ba000d">
                      Please wait your data is being saved..
                    </Typography>
                  </Grid>
                ) : (
                  ""
                )}
                <Button
                  className="Button"
                  variant="contained"
                  style={{ float: "right", width: "80", marginBottom: "5px" }}
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  className="Button"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                  disabled={submitting}
                  style={{
                    float: "right",
                    width: "80px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Box>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          onClose={handleClose}
          open={opendocs}
        >
          <Box sx={styleofmodal}>
            <Grid container>
              <Grid item xs={9}>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{
                    fontWeight: 500,
                    backgroundColor: "#377562",
                    marginBottom: 5,
                    color: "white",
                  }}
                >
                  {FullDocName}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                {submitting ? (
                  <LoadingButton
                    loading
                    loadingIndicator="Downloading"
                    // style={{ position: 'absolute', right: '28px', bottom: '11px' }}
                    color="primary"
                    variant="contained"
                  >
                    Fetch data
                  </LoadingButton>
                ) : (
                  <Button
                    className="Button"
                    size="small"
                    startIcon={<Download />}
                    onClick={() => {
                      download(`${urldownload}`, FullDocName);
                    }}
                    variant="contained"
                    disabled={submitting}
                    style={{
                      // backgroundColor: 'primary',
                      color: "white",
                      float: "right",
                      // position: 'absolute',
                      // marginRight: '28px',
                      // bottom: '11px'
                    }}
                  >
                    Download
                  </Button>
                )}
              </Grid>
              <Grid item xs={1}>
                <CancelOutlinedIcon
                  onClick={handleClose}
                  fontSize="large"
                  color="red"
                  cursor="pointer"
                  style={{ color: "red", marginBottom: 5, float: "right" }}
                ></CancelOutlinedIcon>
              </Grid>
              {/* <Grid item xs={2}></Grid> */}

              {LinkUrl ? (
                //   <Grid item xs={12}>
                //   <Typography variant="body2" style={{ marginBottom: 8 }}>
                //     If the content does not display below,{" "}
                //     <a href={LinkUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1976d2" }}>
                //       click here to open in a new tab
                //     </a>
                //     .
                //   </Typography>
                //   <iframe
                //     title="Linked Document"
                //     src={LinkUrl}
                //     height="500px"
                //     width="100%"
                //     style={{
                //       border: '1px solid #ccc',
                //       borderRadius: '8px',
                //     }}
                //   ></iframe>
                // </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ marginBottom: 8 }}>
                    If the content does not display below,{" "}
                    <span
                      onClick={() =>
                        window.open(
                          LinkUrl,
                          "_blank",
                          "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=1000,height=700"
                        )
                      }
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      click here to open in a new window
                    </span>
                    .
                  </Typography>
                  <iframe
                    title="Linked Document"
                    src={LinkUrl}
                    height="500px"
                    width="100%"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  ></iframe>
                </Grid>
              ) : (DocName && DocName == "jpg") ||
                DocName == "png" ||
                DocName == "jpeg" ? (
                <>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <img
                      height="500px"
                      width="500px"
                      border="4px solid #000"
                      // frameborder='0'
                      // overflow='hidden'
                      src={`${urlFile}`}
                      // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                    ></img>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <iframe
                      height="500px"
                      width="875px"
                      // frameborder='0'
                      // overflow='hidden'
                      src={`${urlFile}`}
                      // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                    ></iframe>
                  </Grid>
                </>
              )}
              {/* <Grid item xs={2}></Grid> */}
              <Grid item xs={12}></Grid>
            </Grid>
          </Box>
        </Modal>
      </Popover>
    </React.Fragment>
  );
};

export default withTranslation()(HelpDropDown);

HelpDropDown.propTypes = {
  t: PropTypes.any,
};
